import React from 'react';
import '../../App.css';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../styles/theme.js';
import { Typography } from '@material-ui/core';

import Card1 from '../../assets/images/card/card1.png';
import Card2 from '../../assets/images/card/card2.png';
import Card3 from '../../assets/images/card/card3.png';
import Card4 from '../../assets/images/card/card4.png';
import Card5 from '../../assets/images/card/card5.png';

const cards = [
  {
    img: Card1,
    title: 'Envíos con efectivo:',
    text:
      'Puedes cargar desde CVS, Walmart y Walgreens o cargar desde una cuenta de bancos de U.S.A.',
  },
  {
    img: Card2,
    title: 'Usamos 1 APP para servicios financieros en México y USA:',
    text:
      'La apertura de cuenta es idéntica a cualquier otro banco en USA y México.',
  },
  {
    img: Card3,
    title: 'La misma APP para transferir dinero',
    text:
      'A ti mismo, a tu familiar u otro. En todo el país de forma inmediata y segura.',
  },
  {
    img: Card4,
    title: 'Tu dinero en dólares',
    text:
      'Puedes mantener tu dinero en dólares en la cuenta de USA.',
  },
  {
    img: Card5,
    title: 'La misma APP para pagos de servicios y carga de saldo',
    text:
      'Desde la facilidad de tu celular.',
  },
];

const MoreOurApp = () => {
  const classes = useStyles();

  return (
    <section className={classes.section}>
      <div className={classes.inner}>
        <div className={classes.rowContainer}>
          <div className={classes.halfContainer}>
            <div className={classes.contentWrap}>
              <Typography className={classes.blackTitle}>
                Además te <br />
                <span className={classes.greenTitle}>simplifica la vida</span>
              </Typography>

              <div className={classes.cardsGrid}>
                {cards.map((card, index) => (
                  <div key={index} className={classes.cardContainer}>
                    <div className={classes.cardImageWrap}>
                      <img
                        src={card.img}
                        alt="card-nerito"
                        className={classes.cardImage}
                      />
                    </div>
                    <span className={classes.cardTitle}>{card.title}</span>
                    <p className={classes.cardText}>{card.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoreOurApp;

const useStyles = makeStyles({
  section: {
    width: '100%',
  },
  inner: {
    width: '100%',
    margin: '0 auto',
    padding: '0 24px',
  },

  rowContainer: {
    display: 'flex',
    width: '100%',
    marginTop: '3%',
    justifyContent: 'center',
  },

  halfContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  contentWrap: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },

  blackTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 60,
    color: theme.palette.black.main,
    textAlign: 'right',
    marginBottom: 40,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 40,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 35,
    },
  },

  greenTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 60,
    color: theme.palette.green.main,
    [theme.breakpoints.down('md')]: {
      fontSize: 40,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 35,
    },
  },

  cardsGrid: {
    width: '100%',
    display: 'grid',
    gap: 30,
    alignItems: 'start',
    paddingBottom: 40,
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',

    [theme.breakpoints.down('sm')]: {
      justifyItems: 'center',
    },
  },

  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 260,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 320,
    },
  },

  cardImageWrap: {
    width: '100%',
    height: 110,
    borderRadius: 10,
    overflow: 'hidden',
    marginBottom: 12,
  },

  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },

  cardTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 6,
  },

  cardText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.5,
  },
});
